module.exports = __webpack_public_path__ + "static/media/about-us.f41fb996.jpg";